import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type OpenBookIconProps = IconProps;

export const OpenBookIcon: FC<OpenBookIconProps> = ({
  iconColor = '#475467',
  className,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 17.5L9.91662 17.3749C9.33775 16.5066 9.04832 16.0725 8.66592 15.7582C8.32738 15.4799 7.9373 15.2712 7.518 15.1438C7.04437 15 6.52259 15 5.47902 15H4.33333C3.39991 15 2.9332 15 2.57668 14.8183C2.26308 14.6586 2.00811 14.4036 1.84832 14.09C1.66667 13.7335 1.66667 13.2668 1.66667 12.3333V5.16667C1.66667 4.23325 1.66667 3.76654 1.84832 3.41002C2.00811 3.09641 2.26308 2.84144 2.57668 2.68166C2.9332 2.5 3.39991 2.5 4.33333 2.5H4.66667C6.53351 2.5 7.46693 2.5 8.17997 2.86331C8.80717 3.18289 9.31711 3.69282 9.63669 4.32003C10 5.03307 10 5.96649 10 7.83333M10 17.5V7.83333M10 17.5L10.0834 17.3749C10.6622 16.5066 10.9517 16.0725 11.3341 15.7582C11.6726 15.4799 12.0627 15.2712 12.482 15.1438C12.9556 15 13.4774 15 14.521 15H15.6667C16.6001 15 17.0668 15 17.4233 14.8183C17.7369 14.6586 17.9919 14.4036 18.1517 14.09C18.3333 13.7335 18.3333 13.2668 18.3333 12.3333V5.16667C18.3333 4.23325 18.3333 3.76654 18.1517 3.41002C17.9919 3.09641 17.7369 2.84144 17.4233 2.68166C17.0668 2.5 16.6001 2.5 15.6667 2.5H15.3333C13.4665 2.5 12.5331 2.5 11.82 2.86331C11.1928 3.18289 10.6829 3.69282 10.3633 4.32003C10 5.03307 10 5.96649 10 7.83333"
      stroke={iconColor}
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.25"
    />
  </svg>
);
